import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import RecibosView from './RecibosView';
import * as ROUTES from '../../../router/Routes';

const RecibosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.recibos} routes={[ROUTES.administracion]}>
      <RecibosView />
    </ContainerTemplate>
  );
};

export default RecibosModule;
